<template>
  <div>
    <b-table
      :data="results"
      paginated
      backend-pagination
      @page-change="onPageChange"
      :total="total"
      :per-page="pageSize"
      :show-detail-icon="true"
      detailed
      detail-key="id"
    >
      <template slot-scope="props">
        <b-table-column field="vanityOrderNumber" label="Bestellung" centered>
          {{ props.row.vanityOrderNumber }}
        </b-table-column>
        <b-table-column field="validFrom" label="Abgeschlossen" centered>
          {{ props.row.orderDate | formatDate }}
        </b-table-column>
        <b-table-column label="Kunde">
          {{ props.row.customer.firstName }} {{ props.row.customer.lastName }}
        </b-table-column>
        <b-table-column label="Kunden E-Mail">
          {{ props.row.customer.email }}
        </b-table-column>
        <b-table-column label="Artikel" centered>
          {{ props.row.orderItems.reduce((a, c) => a + c.quantity, 0) }}
        </b-table-column>
        <b-table-column label="Warenwert" centered>
          {{ props.row.currency | currency }} {{ props.row.summary.subtotal }}
        </b-table-column>
        <b-table-column label="Versand" centered>
          <span v-if="props.row.summary.shippingTotal">
            {{ props.row.currency | currency }}
            {{ props.row.summary.shippingTotal }}
          </span>
          <span>--</span>
        </b-table-column>
        <b-table-column label="Guthaben">
          <span v-if="props.row.summary.prepaid">
            {{ props.row.currency | currency }}
            {{
              props.row.summary.prepaid.reduce((a, c) => a + c.amount, 0)
                | amount
            }}
          </span>
        </b-table-column>
        <b-table-column label="Total">
          {{ props.row.currency | currency }}
          {{ props.row.summary.total | amount }}
        </b-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <div class="">
          <div class="columns is-multiline">
            <div class="column is-12 is-4-widescreen">
              <div class="columns is-multiline">
                <div class="column is-12-widescreen">
                  <p>
                    <strong>
                      {{ props.row.customer.firstName }}
                      {{ props.row.customer.lastName }}
                    </strong>
                    <br />
                    {{ props.row.customer.address }}
                    <br />
                    {{ props.row.customer.country }}
                    {{ props.row.customer.zip }}
                    {{ props.row.customer.city }}
                    <br />
                    {{ props.row.customer.email }}
                  </p>

                  <div class="field is-grouped is-grouped-multiline">
                    <div
                      class="control"
                      v-for="atr in props.row.customer.customerAttributes"
                      :key="atr.attributeName"
                    >
                      <div class="tags has-addons">
                        <span class="tag is-dark">{{ atr.attributeName }}</span>
                        <span class="tag is-info">{{
                          atr.attributeValue
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-12-widescreen">
                  <strong>Gewählte Zahlungsart:</strong><br />
                  <span class="is-block" v-if="props.row.paymentType">
                    {{ props.row.paymentType.paymentTypeName }}
                  </span>

                  <span
                    class="tag is-success"
                    v-if="props.row.paymentType.status == 40"
                    >Bezahlt
                  </span>
                </div>
              </div>
            </div>
            <div class="column is-12 is-8-widescreen">
              <div
                class="box"
                v-for="item in props.row.orderItems"
                :key="item.id"
              >
                <div class="columns is-multiline">
                  <div class="column is-8">
                    <div class="content">
                      <p>
                        <strong>{{ item.title }}</strong>
                        <br />
                        <small>
                          {{ item.subtitle }}
                          <br />
                          {{ item.description }}</small
                        >
                      </p>
                    </div>
                  </div>
                  <div class="column is-4 has-text-right-tablet">
                    <span v-if="item.orderItemReduction">
                      Promotion: {{ item.orderItemReduction.name }} statt
                      {{ item.orderItemReduction.unitPriceBeforeReduction }}
                      <br
                    /></span>
                    <strong>{{ item.quantity }} Stk.</strong> für
                    <strong
                      >{{ item.currency | currency }}
                      {{ item.total | amount }}</strong
                    >
                  </div>
                  <div class="column is-12">
                    <div class="columns is-multiline">
                      <div
                        class="column is-3"
                        v-for="voucher in item.vouchers"
                        :key="voucher.id"
                      >
                        Gutschein
                        <strong v-if="voucher.generated">{{
                          voucher.idSstItem
                        }}</strong
                        >&nbsp;

                        <b-tag v-if="!voucher.generated" type="is-light"
                          >noch nicht generiert</b-tag
                        >
                        <b-tag v-if="voucher.fulfilled" type="is-success"
                          >gedruckt</b-tag
                        >
                        <b-tag v-if="!voucher.fulfilled" type="is-light"
                          >nicht gedruckt</b-tag
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <small
                >Bestellung: {{ props.row.vanityOrderNumber }} ({{
                  props.row.id
                }})</small
              >
            </div>
            <div class="column">
              <!-- Keine Funktionalität derzeit -->
              <!-- <div class="buttons is-pulled-right">
                <b-button type="is-dark" @click="resendMail(props.row)">
                  Bestellbestätigung schicken
                </b-button>
                <b-button type="is-danger" @click="requestStorno(props.row)">
                  Stornieren
                </b-button>
              </div> -->
            </div>
          </div>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'OrdersTable',
  props: {
    results: Array,
    page: Number,
    pageSize: Number,
    total: Number,
  },
  methods: {
    onPageChange(p) {
      this.$emit('request-page', p)
    },
    requestStorno(item) {
      this.$buefy.dialog.confirm({
        title: `Verkauf ${item.vanityOrderNumber} stornieren`,
        message:
          'Sind Sie <strong>sicher</strong> das Sie diesen Verkauf stornieren möchten?',
        confirmText: 'Stornieren',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$buefy.notification.open({
            message: 'Erfolgreich um Stornierung angesucht!',
            type: 'is-success',
          }),
      })
    },
    resendMail(item) {
      this.$buefy.dialog.confirm({
        title: `Email für Bestellung ${item.vanityOrderNumber}`,
        message: `Soll der Kunde erneut über seine Bestellung  ${item.vanityOrderNumber} informiert werden?`,
        confirmText: `Email an  ${item.customer.email}`,
        cancelText: 'Abbrechen',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () =>
          this.$buefy.notification.open({
            message: 'Keine Email konfiguriert!',
            type: 'is-warning',
          }),
      })
    },
  },
}
</script>
